// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"houses-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 9.99951H20V21H4V9.99951H3L6 4.99951H18L21 9.99951Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10 16V21H14V16H10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 16V21H14V16H10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 9.99951V20.9999H20V9.99951M4 9.99951H20M4 9.99951H3L6 4.99951H8M20 9.99951H21L18 4.99951H8M8 4.99951V2.99951","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-houses-2')
export default class Houses2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'houses-2',
    }
  }
}
